import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Header from '../../../../Components/Header';
import SingleSignOnSideBar from '../../../../Components/SingleSignOnSideBar';
import OverviewTopCard from '../../commonComp/OverviewTopCard';
import ProfileIba from '../../commonComp/profileIba/ProfileIba';
import IBAChart from '../../componentiba/IBAChart';
import '../../Pages/Overview/overview.scss';
import topimg from '../../../../asset/images/ibaimages/topimg.svg';
import calliba from '../../../../asset/images/ibaimages/calliba.svg';
import addiba from '../../../../asset/images/ibaimages/addiba.svg';
import personIba from '../../../../asset/images/ibaimages/personIba.svg';
import rejectiba from '../../../../asset/images/ibaimages/rejectiba.svg';
import axios from 'axios';
import { IBA_Admin_Section } from '../../../../Configuration/API_URL';
import DurationChangeComponent from '../../../Reports/DurationChangeComponent';
import IBADuration from '../../../IBAAdmin/IBADuration';
import moment from 'moment';
import { toast } from 'react-toastify';
import { checkDateRange, compareDate, formatDate } from '../../../../CommonMethhods/CommonMethods';
import FromdateComponent from '../../../Reports/FromdateComponent';
import TodateComponent from '../../../Reports/TodateComponent';


const CARD_CONFIG = [
  {
    key: "opened",
    img: topimg,
    // value: overviewDetails?.accountsOpened || 0,
    leble: "Accounts Opened",
    flag: "opened",
    chartTitle: "Account Opening Overview",
  },
  {
    key: "talktime",
    img: calliba,
    // value: overviewDetails?.totalTalkTime || 0,
    leble: "Total TalkTime",
    flag: "talktime",
    chartTitle: "Total Talktime Overview",
  },
  {
    key: "conversion",
    img: addiba,
    // value: overviewDetails?.conversionRate || 0,
    leble: "Conversion Rate",
    flag: "conversion",
    chartTitle: "Conversion Rate Overview",
  },
  {
    key: "submitted",
    img: personIba,
    // value: overviewDetails?.submitedAccounts || 0,
    leble: "Submitted Accounts",
    flag: "submitted",
    chartTitle: "Submitted Accounts Overview",
  },
  {
    key: "rejected",
    img: rejectiba,
    // value: overviewDetails?.rejectedAccounts || 0,
    leble: "Rejected Accounts",
    flag: "rejected",
    chartTitle: "Rejected Accounts Overview",
  },
];

const OverviewPage = () => {
  const [filterModal, setFilterModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [overviewDetails, setOverviewDetails] = useState({});
  const [customShow, setCustomShow] = useState(false);
  const [selectDuration, setSelectDuration] = useState("currentmnth");
  const [graphVal, setGraphVal] = useState([]);
  const [errorResp, setErrorResp] = useState("");
  const [selectedCard, setSelectedCard] = useState(CARD_CONFIG[0]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if(selectDuration !== "custom"){
      const date = new Date();
      const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1))
        .format("MM-DD-YYYY");
      const lastDay = moment(date).format("MM-DD-YYYY");
      setFromDate(firstDay);
      setToDate(lastDay);
    }
  }, []);

  const fetchGraphData = async (flag) => {
    setLoader(true)
    const payload = {
      flag: flag
    }
    try {
      const response = await axios.post(
        IBA_Admin_Section.adminOverviewGraph,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      if (data.status === 0 && Array.isArray(data.data)) {
        const formattedGraphData = data.data.map((item) => ({
          label: item.MonthShort,
          value: Number(item.TotalCount) || 0,
          year: item.Year,
          monthNo: item.MonthNo,
        }));

        setGraphVal(formattedGraphData);
      } else {
        setGraphVal([]);
      }
    } catch (err) {
      console.log(err);
      setGraphVal([]);
    }
    finally{
      setLoader(false);
    }
  };

  console.log(selectDuration, "selectDuration");
  

  useEffect(() => {
    if (selectedCard?.flag) {
      fetchGraphData(selectedCard.flag);
    }
  }, [selectedCard]);

  const getCardDetails = async () => {
    const payload = {
      from_date: fromDate,
      to_date: toDate
    }
    try {
      const response = await axios.post(
        IBA_Admin_Section.overviewCards,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      if (data.status === 0) {
        setOverviewDetails(data.data);
        setFilterModal(false);
      } else {
        setOverviewDetails({});
      }
    } catch (err) {
      console.log(err);
      setOverviewDetails({});
    }
  };

  useEffect(() => {
    if(selectDuration !== "custom"){
      if (fromDate && toDate) {
        getCardDetails();
      }
    }
  }, [fromDate, toDate, selectDuration]);

  const downloadReportData = async () => {
    const payload = {
      from_date: fromDate,
      to_date: toDate,
      flag: selectedCard.flag
    }
    try {
      const response = await axios.post(
        IBA_Admin_Section.adminDownloadFile,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      if (data.status === 0) {
        window.open(data?.data, "_self", "noopener,noreferrer");
      } else {
        toast.error(data?.message)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownload = () => {
    downloadReportData()
  };

  const formatValue = (num) => {
  if (num === null || num === undefined) return 0;

  return Number.isInteger(Number(num))
    ? Number(num)
    : Math.round(Number(num) * 100) / 100;
};

  const dynamicCardData = CARD_CONFIG.map(card => {
  let rawValue =
    card.flag === "opened" ? overviewDetails?.accountsOpened || 0 :
    card.flag === "talktime" ? overviewDetails?.totalTalkTime || 0 :
    card.flag === "conversion" ? overviewDetails?.conversionRate || 0 :
    card.flag === "submitted" ? overviewDetails?.submitedAccounts || 0 :
    overviewDetails?.rejectedAccounts || 0;

  return {
    ...card,
    value: formatValue(rawValue)
    };
  });

  console.log(selectedCard, "selectedCard");


  const onChangeDuration = (selectedValue) => {
    console.log("onChange", selectedValue);

    if (selectedValue === "custom") {
      setErrorResp("")
      setFilterModal(true);


    } else {
      // setRange(selectedValue);
      // overview(selectedValue);
    }

  }

  // const handleSubmit = (e) => {
    
  //   e.preventDefault();

  //   if (fromDate !== "" || toDate !== "") {
  //     if (
  //       compareDate(fromDate) &&
  //       compareDate(toDate) &&
  //       checkDateRange(fromDate, toDate)
  //     ) {
  //       getCardDetails();
  //       setErrorResp("");
  //     } else {
  //       setErrorResp("Please Select Correct Date");
  //     }
  //   }
  //   else {
  //     setErrorResp("Please Select Date");
  //   }
  // };

  const handleSubmit = (e) => {
  e.preventDefault();

  if (!fromDate || !toDate) {
    setErrorResp("Please Select Date");
    return;
  }

  const minAllowedDate = moment("01-01-2000", "MM-DD-YYYY");
  const from = moment(fromDate, "MM-DD-YYYY");
  const to = moment(toDate, "MM-DD-YYYY");

  if (from.isBefore(minAllowedDate)) {
    setErrorResp("From Date cannot be earlier than 01-01-2000");
    return;
  }

  if (to.isBefore(from)) {
    setErrorResp("To Date must be greater than or equal to From Date");
    return;
  }

  if (
    compareDate(fromDate) &&
    compareDate(toDate) &&
    checkDateRange(fromDate, toDate)
  ) {
    setErrorResp("");
    getCardDetails();
  } else {
    setErrorResp("Please Select Correct Date");
  }
};

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp(false);
  };

  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp(false);
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");


  return (
    <div>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="telecallerDash">
        <div className='card-box iba-page'>
          <div className='wrap-header'>
            <div className='module-title'>Overview</div>

            <IBADuration
              setCustomShow={setCustomShow}
              setFromDate={setFromDate}
              setToDate={setToDate}
              onChangeDuration={onChangeDuration}
              setSelectDuration={setSelectDuration}
              selectDuration={selectDuration}
              label={"iba-date"}
            />
          </div>

          <div className="row ibr-card-wrap">
            {dynamicCardData.map((card) => (
              <OverviewTopCard
                key={card?.key}
                cardObj={card}
                isActive={selectedCard?.flag === card?.flag}
                onClick={() => setSelectedCard(card)}
              />
            ))}
          </div>

          <div className='overview-chart'>
            <IBAChart graphDetails={graphVal}
              title={selectedCard.chartTitle}
              handleDownload={handleDownload}
              loader={loader} />
          </div>

          <div className="profile-wrap">
            <ProfileIba overviewDetails={overviewDetails} performerKey="top_performer_1" />
            <ProfileIba overviewDetails={overviewDetails} performerKey="top_performer_2" />
          </div>
        </div>
      </main>

      <Modal
        show={filterModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setFilterModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <form className="profile-modal-content">
            <div className="iput-wrapp">
              <div className="profile-header">Select Custom Date Range</div>

              <div className="profile-form-row">

                <div className="form-group">
                  <FromdateComponent
                    fromDate={handleFromDateChange}
                    formatDate={formatDate(fromDate)}
                    DateReverse={DateReverse}
                  // clientWiseReportForCustomCalanderIcon={true}
                  />
                </div>
                <div className="form-group">
                  <TodateComponent
                    toDate={handleToDateChange}
                    formatToDate={formatDate(toDate)}
                    DateReverse={DateReverse}
                    errorResponse={errorResp}
                  // clientWiseReportForCustomCalanderIcon={true}
                  />
                </div>
              </div>
            </div>

            <div className="profile-footer-iba">
              <Button className="cancel-btn-iba" onClick={() => setFilterModal(false)}>Cancel</Button>
              <Button type="submit" className="save-btn-iba" onClick={handleSubmit}>Apply</Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OverviewPage;
